// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__23fcX","selects":"Documents_selects__1eUgK"};